export const checkIsFunction = (func: unknown) =>
  func && typeof func === "function";
